// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3965":"f5595b7e","5639":"6b8332a1"}[chunkId] + ".chunk.js";
};